import { inject, Injectable } from "@angular/core";

import {
    HtmlSequence,
    HtmlDirective,
    HtmlDirectiveEvaluator,
    HtmlDirectiveEvaluatorSettings,
} from "@main/reporting.v3/widget.html/models";
import {
    HtmlBaseExpressionsArgumentService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-base-expressions-argument.service";


@Injectable()
export class HtmlIndexDirectiveService implements HtmlDirectiveEvaluator {

    private argumentService: HtmlBaseExpressionsArgumentService = inject(HtmlBaseExpressionsArgumentService);

    public readonly directive: string = "index";

    public async evaluate(directive: HtmlDirective, settings: HtmlDirectiveEvaluatorSettings): Promise<any> {
        if (!directive || directive.name !== this.directive || !settings) return null;

        const args: HtmlSequence[] = directive.arguments.slice(0, 2);
        const params: any[] = await this.argumentService.evaluateAll(args, settings);

        const name: string = this.argumentService.toString(params[0]);
        const property: string = this.argumentService.toString(params[1]);

        // Ensure variable name and property name are passed.
        // Make sure variable name consists in an identifier preceded by @.
        if (!name?.length || !property?.length || name[0] !== "@") return null;

        const variable: any = settings.context.variables[name.slice(1)];

        // Ensure the variable value is an object.
        if (variable == null || typeof variable !== "object") return null;

        const value: string = this.argumentService.toString(variable[property]);

        return value;
    }
}